import { createContext } from 'react';

const LightboxContext = createContext(void 0);

LightboxContext.displayName = 'context(Lightbox)';

export default LightboxContext;